<template>
  <div>
    <div>
      <div
        class="flex items-center justify-center p-5 text-center bg-white rounded ">
        <div class="text-2xl font-bold">
          {{ $t('appeal_data.notify') }}
        </div>
      </div>
      <div class="grid grid-cols-5 gap-2 py-3">
        <div>
          <router-link class="router-class" to="change">
            {{ $t('appeal_data.category.change_info') }}
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="document">
            {{ $t('appeal_data.subCategory.document_shop_certify') }}
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="utilities">
            {{ $t('appeal_data.category.facility') }}
          </router-link>
        </div>
        <div>
           <router-link class="router-class" to="improvement">
            {{ $t('appeal_data.category.renovate') }}
          </router-link>
        </div>
        <div>
           <router-link class="router-class" to="repair">
            {{ $t('appeal_data.category.repair') }}
          </router-link>
        </div>
        <div></div>
      </div>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.router-link-exact-active {
  @apply text-screamin-green-700 !important;
}
.router-class {
  @apply bg-white block w-full p-3 text-center text-black transition-all  rounded hover:text-screamin-green-700 hover:scale-110;
}
</style>